/**
 * Side-effect module: replaces the two debounced participation auto-saves' broad "BidV2"
 * invalidation with direct cache patches, so keystrokes don't refetch every bid query.
 */
import { bffApi } from "../../autogen/bff-api";
import type {
  BuyerParticipationRequestDetailDto,
  BuyerParticipationRequestDto,
  UpdateParticipationRequestNotesApiArg,
  UpdateParticipationRequestSelectionDraftApiArg,
} from "../../autogen/bff-api";

bffApi.enhanceEndpoints({
  endpoints: {
    updateParticipationRequestNotes: {
      invalidatesTags: [],
      async onQueryStarted(
        arg: UpdateParticipationRequestNotesApiArg,
        { dispatch, queryFulfilled },
      ) {
        try {
          const { data: detail } = await queryFulfilled;
          const updatedRequest = (detail as BuyerParticipationRequestDetailDto).request;
          if (!updatedRequest) return;

          // Patch the list query cache
          dispatch(
            bffApi.util.updateQueryData(
              "listParticipationRequestsForBuyer",
              { eventId: arg.eventId },
              (draft) => {
                if (!draft.requests) return;
                const idx = draft.requests.findIndex((r) => r.id === arg.requestId);
                if (idx !== -1) {
                  draft.requests[idx] = updatedRequest as BuyerParticipationRequestDto;
                }
              },
            ),
          );

          // Patch the detail query cache
          dispatch(
            bffApi.util.updateQueryData(
              "getParticipationRequestForBuyer",
              { eventId: arg.eventId, requestId: arg.requestId },
              (draft) => {
                draft.request = updatedRequest as BuyerParticipationRequestDto;
              },
            ),
          );
        } catch {
          // Network/server error — the existing error handling in the caller handles this.
        }
      },
    },

    updateParticipationRequestSelectionDraft: {
      invalidatesTags: [],
      async onQueryStarted(
        arg: UpdateParticipationRequestSelectionDraftApiArg,
        { dispatch, queryFulfilled },
      ) {
        try {
          const { data: updatedRequest } = await queryFulfilled;

          // Patch the list query cache
          dispatch(
            bffApi.util.updateQueryData(
              "listParticipationRequestsForBuyer",
              { eventId: arg.eventId },
              (draft) => {
                if (!draft.requests) return;
                const idx = draft.requests.findIndex((r) => r.id === arg.requestId);
                if (idx !== -1) {
                  draft.requests[idx] = updatedRequest as BuyerParticipationRequestDto;
                }
              },
            ),
          );

          // Patch the detail query cache
          dispatch(
            bffApi.util.updateQueryData(
              "getParticipationRequestForBuyer",
              { eventId: arg.eventId, requestId: arg.requestId },
              (draft) => {
                draft.request = updatedRequest as BuyerParticipationRequestDto;
              },
            ),
          );
        } catch {
          // Network/server error — the existing error handling in the caller handles this.
        }
      },
    },
  },
});
